import React from "react";

import Button from "../Button";
import Step from "./Step";

export default function DuplicateSaleWarning({ classe, step = "Vos coordonnées", payment, onContinue, onCancel }) {
  const date = payment?.date != null
    ? new Date(payment.date).toLocaleString("fr-FR", {
        day: "2-digit",
        month: "long",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      })
    : "—";

  return (
    <Step classe={classe} step={step}>
      <div style={{ padding: "8px 0" }}>
        <div style={{
          background: "#FFFBEB",
          border: "1px solid #FDE68A",
          borderRadius: 12,
          padding: "20px 24px",
          display: "flex",
          flexDirection: "column",
          gap: 16,
          maxWidth: 420,
          margin: "0 auto",
        }}>
          <div style={{ display: "flex", alignItems: "flex-start", gap: 14 }}>
            <span style={{ fontSize: 28, lineHeight: 1 }}>⚠️</span>
            <div>
              <p style={{ fontWeight: 700, fontSize: 16, color: "#92400E", margin: "0 0 4px" }}>
                Souscription récente détectée
              </p>
              <p style={{ color: "#78350F", fontSize: 14, margin: 0, lineHeight: 1.5 }}>
                Vous avez déjà souscrit un abonnement dans ce club il y a moins de 24 h. Vérifiez qu'il ne s'agit pas d'un doublon avant de continuer.
              </p>
            </div>
          </div>

          <div style={{
            background: "#FEF3C7",
            borderRadius: 8,
            padding: "12px 16px",
            display: "flex",
            justifyContent: "space-between",
            fontSize: 13,
            color: "#92400E",
          }}>
            <span style={{ fontWeight: 600 }}>Date</span>
            <span>{date}</span>
          </div>

          <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
            <Button variant="primary" onClick={onContinue}>
              Continuer quand même
            </Button>
            <Button onClick={onCancel}>
              Annuler
            </Button>
          </div>
        </div>
      </div>
    </Step>
  );
}
